import { createSlice, PayloadAction, Slice } from "@reduxjs/toolkit";
import { RootState } from "utils/store";

export interface PreferenceState {
  layout: string;
  theme: string;
  sideNavCollpased: boolean;
  defaultDateFormat: string;
}

const initialState: PreferenceState = {
  layout: "",
  theme: "dark",
  sideNavCollpased: false,
  defaultDateFormat: "MM/DD/YYYY",
};

export const preferenceSlice: Slice = createSlice({
  name: "preference",
  initialState,
  reducers: {
    updatePreference: (
      state,
      action: PayloadAction<{
        layout: string;
        theme: string;
      }>
    ) => {
      state.layout = action.payload.layout;
      state.theme = action.payload.theme;
    },
    updateTheme: (state, action: PayloadAction<string>) => {
      state.theme = action.payload;
    },
    updateLayout: (state, action: PayloadAction<string>) => {
      state.layout = action.payload;
    },
    updateSideNavCollpased: (state, action: PayloadAction<boolean>) => {
      state.sideNavCollpased = action.payload;
    },
    updateDefaultDateFormat: (state, action: PayloadAction<string>) => {
      state.defaultDateFormat = action.payload;
    },
  },
});

export const {
  updatePreference,
  updateTheme,
  updateLayout,
  updateSideNavCollpased,
  updateDefaultDateFormat,
} = preferenceSlice.actions;

export const selectLayout = (state: RootState) => state.preference.layout;
export const selectTheme = (state: RootState) => state.preference.theme;
export const selectSideNavCollpased = (state: RootState) =>
  state.preference.sideNavCollpased;
export const selectDefaultDateFormat = (state: RootState) =>
  state.preference.defaultDateFormat ?? "MM/DD/YYYY";

export default preferenceSlice.reducer;
